import script from "./MyHome.vue?vue&type=script&setup=true&lang=js"
export * from "./MyHome.vue?vue&type=script&setup=true&lang=js"

import "./MyHome.vue?vue&type=style&index=0&id=af50629c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af50629c"]])

export default __exports__